import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './EstimatesBlock.module.css';
import { useEstimatesBlock } from './useEstimatesBlock';
import { Tabs } from '../../../../components/newUI/Tabs/Tabs';

interface EstimatesBlockProps {
    classes?: string;
}

export const EstimatesBlock = memo(({ classes }: EstimatesBlockProps) => {
    const { activeTab, tabsList, tabsContentMapping, onTabChange } = useEstimatesBlock();

    return (
        <div id="project_progress" className={classNames(cls.EstimatesBlock, [classes])}>
            <span className={cls.EstimateTitle}>
                {i18next.t('EstimatesBlock.return.estimateTitle')}
            </span>
            <div className={cls.Content}>
                <Tabs
                    classes={cls.Tabs}
                    onChange={onTabChange}
                    tabsList={tabsList}
                    activeTab={activeTab}
                    classesTabs={cls.TabsStyle}
                />
                <div className={cls.Estimates}>{tabsContentMapping[activeTab]}</div>
            </div>
        </div>
    );
});
